<template>
  <div class="accordian-item day" v-show="!(hideDisabled && disabled)" :class="{'disabled': disabled, 'is-closed': opening.closed}"
       :style="{'background-color': color}">
    <div class="header" @click.prevent="toggleOpen">
      <div class="header-title">
        <span>{{ convertToMilitaryTime(opening.start_time) }}</span>
      </div>
    </div>
    <div class="body">
      <!-- p>{{ opening.week_day_label }}</p -->
      <p>{{ convertToMilitaryTime(opening.start_time) }}-{{ convertToMilitaryTime(opening.end_time) }}</p>
      <p v-for="instructor in opening.instructors">{{ instructor }}</p>
      <p class="count-openings">{{ opening.openings }} {{ str_openings() }}</p>
      <a :href="formatLink(opening.link)" target="_blank" class="btn register-button">Register</a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    /*disabled: {
        default: false,
    },
    closed: {
        default: true
    },*/
    hideDisabled: {
      default: false
    },
    opening: {
      required: true,
    },
    color: {
      required: false,
      default: '#ca8be3'
    }
  },

  data(){
    return {
      //disabled: false,
      //closed: true
    }
  },

  computed: {
    disabled() {
      return this.opening.openings < 1
    }
  },

  methods: {
    __(label) {
      return label
    },
    toggleOpen(){
      if (this.disabled) return
      this.opening.closed = !this.opening.closed
    },
    str_openings(){
      if (this.opening.openings > 1) {
        return this.__('openings')
      } else {
        return this.__('opening')
      }
    },

    getParameterByName(name, url = window.location.href) {
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },

    formatLink(link) {
      // Add loc
      var loc = this.getParameterByName('loc')
      return link.replaceAll('&amp;', '&') + (loc != null ? loc : '')
    },

    convertToMilitaryTime(str){
      var h1 = Number(str[0] - '0');
      var h2 = Number(str[1] - '0');

      var hh = h1 * 10 + h2;

      var Meridien;

      if (hh < 12) {
        Meridien = "AM";
      }
      else
        Meridien = "PM";

      hh %= 12;

      let result = "";

      // Handle 00 and 12 case separately
      if (hh == 0) {
        result += "12";

        // Printing minutes
        for (var i = 2; i < str.length; ++i) {
          result += str[i];
        }
      }
      else {
        result += hh;
        // Printing minutes
        for (var i = 2; i < str.length; ++i) {
          result += str[i];
        }
      }

      return result + " " + Meridien ;

      return result;
    }
  }
}
</script>
